import { useMutation } from '@tanstack/react-query';
import { forgottenPassword } from '../services/auth';
import type { ForgottenPasswordRequest, LogoutResponse } from '../services/auth';

export const useForgotPassword = () => {
    return useMutation<LogoutResponse, Error, ForgottenPasswordRequest>({
        mutationFn: (payload) => forgottenPassword(payload),
    });
};
